<template>
  <Modal  :lock-scroll="true" :title="title" v-model="show" :width="width" :fullscreen="fullscreen" :draggable="draggable" @on-ok="handleOk">
    <slot name="slotContent"></slot>
  </Modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '默认'
    },
    width: {
      type: String,
      default: '30%'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    handleOk() {
      this.$emit('handle-ok')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modal/index.vue